<template>
  <div class="footerMenu">
    <div class="footInfo">
      <div class="row">
        <span>Copyright © {{ year }}</span>
        <span>江苏希地丰华项目管理集团有限公司</span>
        <span><a href="https://beian.miit.gov.cn/" target="blank">苏ICP备09066976号-1</a></span>
      </div>
      <div class="row">
        <span>地址：南京市 · 雨花台区 · 宁双路19号中国(南京)软件谷云密城K栋17层</span>
        <span>邮编：210012</span>
        <span>电话：025-51860071 或 18951936689、18912954347</span>
        <!-- <span>传真：025-51860005</span> -->
      </div>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterMenu",
  props: {},
  data() {
    return {
      cur: 0,
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style scoped lang="scss">
.footerMenu {
  .footInfo {
    width: 100%;
    height: 80px;
    padding: 10px 0;
    align-items: center;
    background: $color-3;
    color: $color-white;
    overflow: hidden;
    .row {
      line-height: 30px;
      display: flex;
      justify-content: center;
    }
    span {
      padding: 0 8px;
      a {
        color: $theme-color;
      }
    }
  }
}
</style>
